"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import CardCompany from "@/components/CardCompany";
import CardFund from "@/components/CardFund";
import { Container } from "@/components/Container";
import { motion, useScroll, useTransform } from "framer-motion";
import { BorderFollower } from "./BorderFollower";
import { LogoIcon } from "./LogoIcon";
import { useSpotlight } from "./Spotlight";
export function CallToAction() {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      size: 400,
      initialY: 200,
      resetOnExit: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    containerProps
  } = useSpotlight(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["start end", "end start"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== containerProps.ref) {
    t2 = {
      target: containerProps.ref,
      offset: t1
    };
    $[2] = containerProps.ref;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    scrollYProgress
  } = useScroll(t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [0, 0.5];
    t4 = [-100, 0];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  const y = useTransform(scrollYProgress, t3, t4);
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [0, 0.5];
    t6 = [-50, 0];
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  const xLeft = useTransform(scrollYProgress, t5, t6);
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [0, 0.5];
    t8 = [50, 0];
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  const xRight = useTransform(scrollYProgress, t7, t8);
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute -top-px left-0 right-0 h-[1.5px] bg-[linear-gradient(90deg,transparent,rgb(46,46,46,0.05)_25%,rgba(112,112,112,1)_50%,rgba(56,189,248,0.05)_75%,transparent)]" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== xLeft || $[12] !== y) {
    t10 = {
      y,
      x: xLeft,
      z: 0.0001
    };
    $[11] = xLeft;
    $[12] = y;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      y: 0,
      x: 0
    };
    t12 = <CardCompany />;
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10) {
    t13 = <motion.div className="fade-bottom pointer-events-none absolute left-6 top-6 z-0 opacity-40 md:left-6 md:top-auto md:flex lg:opacity-100" style={t10} initial={t11}>{t12}</motion.div>;
    $[16] = t10;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== xRight || $[19] !== y) {
    t14 = {
      y,
      x: xRight,
      z: 0.0001
    };
    $[18] = xRight;
    $[19] = y;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      y: 0,
      x: 0
    };
    t16 = <CardFund />;
    $[21] = t15;
    $[22] = t16;
  } else {
    t15 = $[21];
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t14) {
    t17 = <motion.div className="pointer-events-none absolute -right-0 z-0 hidden opacity-10 md:right-6 md:flex md:scale-100 lg:opacity-100" style={t14} initial={t15}>{t16}</motion.div>;
    $[23] = t14;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  let t19;
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LogoIcon className="mx-auto mb-6 size-[68px] md:size-[80px]" />;
    t19 = <h2 className="font-fundra text-3xl text-[28px] font-bold tracking-tight text-white sm:text-4xl">Get started today</h2>;
    t20 = <p className="mt-4 text-balance px-2 text-base tracking-tight text-gray-400 sm:text-lg">It’s time to take your fund admin to the next level and start allocating your dry powder wisely.</p>;
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
  } else {
    t18 = $[25];
    t19 = $[26];
    t20 = $[27];
  }
  let t21;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="absolute inset-0 transform-gpu overflow-hidden rounded-xl p-0"><BorderFollower duration={4000} rx="30%" ry="30%"><div className="h-[92px] w-[92px] bg-[radial-gradient(#10b981,transparent_65%)] opacity-80 group-hover:w-[200px]" /></BorderFollower></div>;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="relative z-10 mx-auto max-w-lg text-center">{t18}{t19}{t20}<Button className="relative z-10 mt-10 rounded-xl border-0 bg-white/10 p-[1.5px] text-[14.5px] font-bold shadow-sm shadow-black/80" color="custom" data-cal-link="fundra/demo" onClick={_temp}>{t21}<div className="pointer-events-none relative flex items-center justify-center rounded-[10px] bg-black/60 bg-gradient-to-b from-neutral-900/40 to-black/40 px-8 py-4 transition-colors duration-300 ease-in hover:bg-black/80 md:backdrop-blur-md"><div className="text-white">{"Book a demo & get a free trial"}</div></div></Button></div>;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== containerProps || $[31] !== t13 || $[32] !== t17) {
    t23 = <section id="get-started-today" className="over relative -mb-20"><Container innerClassName="px-1"><div className="relative overflow-hidden rounded-xl rounded-b-none border border-b-0 border-white/5 py-16 shadow-sm shadow-black/40" {...containerProps}>{t9}{t13}{t17}{t22}</div></Container></section>;
    $[30] = containerProps;
    $[31] = t13;
    $[32] = t17;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  return t23;
}
async function _temp() {
  window.Cal("modal", {
    calLink: "fundra/demo",
    config: {
      subscribe: "true"
    }
  });
}